import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconFormIndicatorInfo(props: IconProps) {
  return (
    <BaseIcon color="elementBlue100" {...props}>
      <path
        d="M19.778 2H4.222C3 2 2 3 2 4.222v15.556C2 21 3 22 4.222 22h15.556C21 22 22 21 22 19.778V4.222C22 3 21 2 19.778 2Z"
        fill="currentColor"
      />
      <path d="M12 18v-7h-2" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
      <rect x="10.5" y="5" width="3" height="3" rx="1.5" fill="#fff" />
    </BaseIcon>
  );
}
